import { createIndexableMetas } from './indexable-metas';
import { createBasicMetas } from './basic-metas';
import { createOpenGraphMetas } from './open-graph-metas';
import { createTwitterMetas } from './twitter-metas';
import { createFacebookMetas } from './facebook-metas';
import { createThemeMetas } from './theme-metas';
import { createMsAppMetas } from './msapp-metas';

function pageMetadataBuilder({
  basic = {},
  og = {},
  twitter = {},
  fb = {},
  ms = {}
}) {
  const indexableMetas = createIndexableMetas({
    indexable: basic.indexable
  });

  const basicMetas = createBasicMetas({
    title: basic.title,
    description: basic.description
  });

  const openGraphMetas = createOpenGraphMetas({
    title: og.title,
    description: og.description,
    type: og.type,
    imageUrl: og.imageUrl,
    siteName: og.siteName,
    url: og.url,
    locale: og.locale
  });

  const twitterMetas = createTwitterMetas({
    card: twitter.card,
    title: twitter.title,
    description: twitter.description,
    imageSrc: twitter.imageUrl,
    url: twitter.url
  });

  const facebookMetas = createFacebookMetas({
    appId: fb.appId
  });

  const themeMetas = createThemeMetas();
  const msAppMetas = createMsAppMetas(ms);

  return [
    ...indexableMetas,
    ...basicMetas,
    ...openGraphMetas,
    ...twitterMetas,
    ...facebookMetas,
    ...themeMetas,
    ...msAppMetas
  ];
}

export default pageMetadataBuilder;
